import { render, staticRenderFns } from "./FormRepeaterBasic.vue?vue&type=template&id=80787d44&scoped=true&"
import script from "./FormRepeaterBasic.vue?vue&type=script&lang=js&"
export * from "./FormRepeaterBasic.vue?vue&type=script&lang=js&"
import style0 from "./FormRepeaterBasic.vue?vue&type=style&index=0&id=80787d44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80787d44",
  null
  
)

export default component.exports